module.exports = __webpack_public_path__ + "img/202627_a_fr.7cba48c3.png";